import LandInfo from './land-info/land-info.vue'; // 耕地类型地块信息
import ProjectType2 from './project-type-2/project-type-2.vue'; // 林地
import ProjectType3 from './project-type-3/project-type-3.vue'; // 水面
import ProjectType4 from './project-type-4/project-type-4.vue'; // 四荒
import ProjectType6 from './project-type-6/project-type-6.vue'; // 房屋
import ProjectType7 from './project-type-7/project-type-7.vue'; // 设备设施
import ProjectType8 from './project-type-8/project-type-8.vue'; // 综合类
import ProjectType9 from './project-type-9/land-info.vue'; // 草地

export default {
  components: {
    LandInfo,
    ProjectType2,
    ProjectType3,
    ProjectType4,
    ProjectType6,
    ProjectType7,
    ProjectType8,
    ProjectType9
  },
  props: {
    projectInfo: {
      type: Object,
      default: {}
    },
    bidInfo: {
      type: Object,
      default: {}
    },
    NoneedtoShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    needtoShow() {
      return this.NoneedtoShow;
    },
    projectType () {
      return this.projectInfo && this.projectInfo.projectType;
    },
    projectSubType () {
      return this.projectInfo && this.projectInfo.projectSubType;
    },
    transferType () {
      return this.projectInfo && this.projectInfo.transferType;
    },
    assetsArr () {
      if (this.bidInfo && this.bidInfo.detail && this.bidInfo.detail.length > 0) {
        const lands = this.bidInfo.detail.map(item => {
          item = {
            ...item,
            ...JSON.parse(item.assetsInfo),
            checked: item.checked
          };
          return item;
        });
        return lands;
      } else if (this.projectInfo) {
        let lands = null;
        // 综合类内部不需要转换
        if(Number(this.projectInfo.projectType) === 8) {
          lands = [JSON.parse(this.projectInfo.assetsInfo)];
        } else {
          lands = JSON.parse(this.projectInfo.assetsInfo).map(item => JSON.parse(item));
        }
        return lands;
      } else {
        return [];
      }
    }
  },
  methods: {
    checkBid (index, item) {
      if (item.isDisable || this.transferType === 1) {return;}
      this.$emit('selectAssets', index);
    }
  }
};
